import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormFeedback, Input } from "reactstrap";

import * as Yup from "yup";
import { useFormik } from "formik";
import { addNote, updatePart } from "../../../../slices/thunks";

const NoteModal = ({partDetails, show, onCloseClick}) => {
    const dispatch = useDispatch();

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: { note: "" },
        validationSchema: Yup.object({ note: Yup.string().required("Molimo unesite bilješku.") }),
        onSubmit: (values) => {
            let note = {
                parentId: partDetails.id,
                title: partDetails.publicIdentifier + ' - ' + partDetails.name,
                description: values.note,
                isActive: true,
                noteType: 4                    
            };
            if (partDetails.note) {
                note.id = partDetails.note.id;
                console.log(note);
            }
            const updatedPart = {...partDetails, note: note, status: 3};
            console.log(updatedPart);
            dispatch(updatePart(updatedPart));    
            handleOnCloseClick();
        },
    });

    const handleFormSubmit = (e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
    };

    const handleOnCloseClick = () => {
        validation.resetForm();
        onCloseClick();
    };

    return(
        <Modal id="noteModal" isOpen={show} toggle={handleOnCloseClick} centered backdrop={"static"}>
            <ModalHeader className="bg-light p-3" toggle={handleOnCloseClick}> Dodaj bilješku </ModalHeader>
            <Form className="tablelist-form" onSubmit={handleFormSubmit}>
            <ModalBody>
                <div className="row gy-4 mb-3">
                    <div className="col-md-6 input-group">                      
                        <Input name="note" type="text" className="form-control"
                            placeholder="Bilješka"                      
                            validate={{ required: { value: true }}}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.note}
                            invalid={validation.touched.note && validation.errors.note ? true : false}
                        />
                        {validation.touched.note && validation.errors.note ? (<FormFeedback type="invalid">{validation.errors.note}</FormFeedback>) : null}
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="hstack gap-2 justify-content-end">
                    <button type="button" className="btn btn-light" onClick={() => {handleOnCloseClick()}}> Zatvori </button>
                    <button type="submit" className="btn btn-success"> Dodaj bilješku </button>
                </div>
            </ModalFooter>
            </Form>
        </Modal>
    );
};

export default NoteModal;